import './App.css';
import AppRoutes from './routes/routes';
import './common.css'
import 'react-toastify/dist/ReactToastify.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthWatcher from './utils/authWatcher';

function App() {
  return (
    <div >
        <Router>
          <AuthWatcher/>
        <AppRoutes/>
        <ToastContainer/>
        </Router>
    </div>
  );
}

export default App;
